import { SpinnerLoading } from '@sobrus-com/sobrus-design-system-v2';

const PageLoader = () => (
	<div className="sns">
		<div className="loader">
			<SpinnerLoading loading />
		</div>
	</div>
);

export default PageLoader;
